import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { CopyIcon, ExternalLinkIcon } from 'lucide-react';
import { useState } from 'react';

interface CopyableUrlRowProps {
	label: string;
	url: string;
	onCopy: (text: string) => void;
	className?: string;
	showOpenLink?: boolean;
}

export default function CopyableUrlRow({ label, url, onCopy, className, showOpenLink = true }: CopyableUrlRowProps) {
	const [expanded, setExpanded] = useState(false);
	const isLong = url.length > 48;

	return (
		<div className={cn('flex min-w-0 flex-col gap-1', className)}>
			<span className='text-sm font-medium'>{label}</span>
			<div className='flex min-w-0 items-start gap-2 overflow-hidden rounded-md border border-border bg-muted/30 px-3 py-2'>
				<code
					className={cn(
						'min-w-0 flex-1 overflow-hidden text-xs',
						expanded ? 'break-all' : 'truncate',
					)}
				>
					{url}
				</code>
				<div className='flex gap-0.5 shrink-0'>
					{isLong ? (
						<Button
							type='button'
							variant='ghost'
							size='sm'
							className='h-8 px-2 text-xs'
							onClick={() => setExpanded(v => !v)}
						>
							{expanded ? 'Свернуть' : 'Показать'}
						</Button>
					) : null}
					<Button type='button' variant='ghost' size='icon' className='size-8' onClick={() => onCopy(url)}>
						<CopyIcon size={14} />
					</Button>
					{showOpenLink ? (
						<Button type='button' variant='ghost' size='icon' className='size-8' asChild>
							<a href={url} target='_blank' rel='noopener noreferrer'>
								<ExternalLinkIcon size={14} />
							</a>
						</Button>
					) : null}
				</div>
			</div>
		</div>
	);
}
